(function () {
  'use strict';

  if (window.__quantityDropdownInit__) return;
  window.__quantityDropdownInit__ = true;
  console.info('[qty-dropdown] quantity-dropdown.js initialized');

  var QUANTITY_MAX_OPTIONS = 24;
    var QUANTITY_CUSTOM_VALUE = '__custom__';

    // Persist last valid select values across cart-section morphs. Keyed by the
    // container element so the value survives even when select children are
    // replaced. Using a WeakMap so detached containers are garbage collected.
    var lastValidByContainer = new WeakMap();
    // Track which dialog Promises are pending per select to avoid stacking
    // multiple custom-quantity dialogs if the user double-clicks.
    var pendingDialogBySelect = new WeakMap();

    // Debug: ?qty_debug=1 | localStorage.setItem('qty-dropdown-debug','1') | window.__qtyDropdownDebug__ = true
    function qtyDebugEnabled() {
      if (typeof window === 'undefined') return false;
      if (window.__qtyDropdownDebug__) return true;
      try {
        if (window.localStorage && window.localStorage.getItem('qty-dropdown-debug') === '1') return true;
      } catch (_) {}
      try {
        if (window.location && window.location.search && window.location.search.indexOf('qty_debug=1') !== -1) return true;
      } catch (_) {}
      return false;
    }

    function qtyLog() {
      if (!qtyDebugEnabled()) return;
      var args = ['[qty-dropdown]'].concat([].slice.call(arguments));
      console.log.apply(console, args);
    }

    function qtyWarn() {
      var args = ['[qty-dropdown]'].concat([].slice.call(arguments));
      console.warn.apply(console, args);
    }

    if (qtyDebugEnabled()) {
      console.info(
        '[qty-dropdown] Debug logging ON. Disable: localStorage.removeItem("qty-dropdown-debug") or remove ?qty_debug=1'
      );
    }

    function getVariantStockMap(container) {
      try {
        return JSON.parse(container.dataset.variantStock || '{}');
      } catch (e) {
        return {};
      }
    }

    function getStockForVariant(stockMap, variantId) {
      if (!variantId) return -1;
      var raw = stockMap[String(variantId)];
      if (raw === undefined || raw === null) return -1;
      var n = parseInt(raw, 10);
      return isNaN(n) ? -1 : n;
    }

    function rebuildQuantityOptions(quantitySelect, stockForVariant) {
      if (!quantitySelect) return;
      var previousValueNum = parseInt(quantitySelect.value, 10);
      var unlimited = stockForVariant == null || stockForVariant < 0;
      var maxOptions;
      var showPlus = false;

      if (unlimited) {
        maxOptions = QUANTITY_MAX_OPTIONS;
        showPlus = true;
      } else if (stockForVariant > QUANTITY_MAX_OPTIONS) {
        maxOptions = QUANTITY_MAX_OPTIONS;
        showPlus = true;
      } else {
        maxOptions = Math.max(1, stockForVariant);
      }

      while (quantitySelect.firstChild) {
        quantitySelect.removeChild(quantitySelect.firstChild);
      }
      for (var i = 1; i <= maxOptions; i++) {
        var opt = document.createElement('option');
        opt.value = String(i);
        opt.textContent = String(i);
        quantitySelect.appendChild(opt);
      }
      if (showPlus) {
        var plusOpt = document.createElement('option');
        plusOpt.value = QUANTITY_CUSTOM_VALUE;
        plusOpt.textContent = '+';
        quantitySelect.appendChild(plusOpt);
      }

      var maxAllowed = unlimited ? Infinity : Math.max(1, stockForVariant);
      if (!isNaN(previousValueNum) && previousValueNum >= 1 && previousValueNum <= maxOptions) {
        quantitySelect.value = String(previousValueNum);
      } else if (!isNaN(previousValueNum) && previousValueNum > maxOptions && previousValueNum <= maxAllowed) {
        var customOpt = document.createElement('option');
        customOpt.value = String(previousValueNum);
        customOpt.textContent = String(previousValueNum);
        customOpt.dataset.customQuantity = 'true';
        if (showPlus) {
          quantitySelect.insertBefore(customOpt, quantitySelect.lastElementChild);
        } else {
          quantitySelect.appendChild(customOpt);
        }
        quantitySelect.value = String(previousValueNum);
      } else {
        quantitySelect.value = '1';
      }
    }

    function setCustomQuantity(quantitySelect, value) {
      if (!quantitySelect) return;
      var existingCustom = quantitySelect.querySelector('option[data-custom-quantity="true"]');
      if (existingCustom) existingCustom.remove();
      var matchingNumeric = quantitySelect.querySelector('option[value="' + String(value) + '"]');
      if (matchingNumeric) {
        quantitySelect.value = String(value);
        return;
      }
      var customOpt = document.createElement('option');
      customOpt.value = String(value);
      customOpt.textContent = String(value);
      customOpt.dataset.customQuantity = 'true';
      var plusOpt = quantitySelect.querySelector('option[value="' + QUANTITY_CUSTOM_VALUE + '"]');
      if (plusOpt) {
        quantitySelect.insertBefore(customOpt, plusOpt);
      } else {
        quantitySelect.appendChild(customOpt);
      }
      quantitySelect.value = String(value);
    }

    // Native <dialog> + showModal() so it joins the browser top layer above
    // any open cart-drawer <dialog>. A plain div with z-index can never stack
    // above another element that's currently in the top layer, no matter how
    // large the z-index value. Duplicate dialogs are prevented by event
    // delegation + the pendingDialogBySelect guard above.
    function showCustomQuantityDialog(stockForVariant) {
      return new Promise(function(resolve) {
        var translations = (window.Theme && window.Theme.translations) || {};
        var titleText = translations.custom_quantity_title || 'Enter quantity';
        var messageText = translations.custom_quantity_message || 'How many bottles would you like to add?';
        var applyText = translations.custom_quantity_apply || 'Apply';
        var cancelText = translations.custom_quantity_cancel || 'Cancel';
        var hintTemplate = translations.custom_quantity_max_hint || 'Maximum available: __COUNT__';
        var exceedsTemplate = translations.custom_quantity_exceeds_stock || 'Allocation limit reached';
        var hasFiniteStock = stockForVariant != null && stockForVariant >= 0;
        var hintText = hasFiniteStock
          ? hintTemplate.replace('__COUNT__', String(stockForVariant))
          : '';

        var dialog = document.createElement('dialog');
        dialog.className = 'primeurs-cart-guard-dialog wine-custom-quantity-dialog';
        dialog.setAttribute('aria-label', titleText);
        dialog.style.cssText = [
          'background: var(--color-background, #fff)',
          'color: var(--color-foreground, #000)',
          'border: 1px solid rgb(var(--color-foreground-rgb) / 0.25)',
          'border-radius: 4px',
          'padding: 20px 22px',
          'max-width: 24rem',
          'width: calc(100% - 2rem)',
          'box-shadow: 0 10px 40px rgba(0, 0, 0, 0.18)'
        ].join(';');
        dialog.innerHTML = '' +
          '<div class="primeurs-cart-guard-dialog__content">' +
            '<h3 style="margin: 0 0 8px;">' + titleText + '</h3>' +
            '<p style="margin: 0 0 6px;">' + messageText + '</p>' +
            (hintText ? '<p style="opacity: 0.7; font-size: 0.85em; margin: 0 0 4px;">' + hintText + '</p>' : '') +
            '<input type="number" min="1" ' + (hasFiniteStock ? 'max="' + stockForVariant + '"' : '') + ' step="1" inputmode="numeric" ' +
              'data-custom-quantity-input ' +
              'style="width: 100%; padding: 8px 10px; font-size: 1rem; border: 1px solid rgb(var(--color-foreground-rgb) / 0.4); background: var(--color-background); color: var(--color-foreground); margin-top: 8px;" />' +
            '<p data-custom-quantity-error style="color: #c0392b; font-size: 0.85em; margin: 6px 0 0 0; min-height: 1.2em;"></p>' +
            '<div class="primeurs-cart-guard-dialog__actions" style="display:flex; align-items:center; gap:0.75rem; flex-wrap:nowrap; margin-top: 12px;">' +
              '<button type="button" class="button button-secondary" data-action="cancel">' + cancelText + '</button>' +
              '<button type="button" class="button button-primary" data-action="apply">' + applyText + '</button>' +
            '</div>' +
          '</div>';

        var input = dialog.querySelector('[data-custom-quantity-input]');
        var errorEl = dialog.querySelector('[data-custom-quantity-error]');
        var cancelBtn = dialog.querySelector('[data-action="cancel"]');
        var applyBtn = dialog.querySelector('[data-action="apply"]');

        var resolved = false;
        function finish(value) {
          if (resolved) return;
          resolved = true;
          try { dialog.close(); } catch (_) {}
          if (dialog.parentNode) dialog.parentNode.removeChild(dialog);
          resolve(value);
        }

        function tryApply() {
          var raw = (input && input.value || '').trim();
          var value = parseInt(raw, 10);
          if (!raw || isNaN(value) || value < 1) {
            if (errorEl) errorEl.textContent = messageText;
            return;
          }
          if (hasFiniteStock && value > stockForVariant) {
            if (errorEl) errorEl.textContent = exceedsTemplate.replace('__COUNT__', String(stockForVariant));
            return;
          }
          finish(value);
        }

        if (applyBtn) {
          applyBtn.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            tryApply();
          });
        }
        if (cancelBtn) {
          cancelBtn.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            finish(null);
          });
        }
        dialog.addEventListener('cancel', function(e) {
          e.preventDefault();
          finish(null);
        });
        // Clicking the ::backdrop reports the dialog itself as the target.
        dialog.addEventListener('click', function(e) {
          if (e.target === dialog) finish(null);
        });
        if (input) {
          input.addEventListener('keydown', function(e) {
            if (e.key === 'Enter') {
              e.preventDefault();
              tryApply();
            }
          });
        }

        document.body.appendChild(dialog);
        try {
          dialog.showModal();
        } catch (_) {
          // Fallback for environments where showModal isn't available.
          dialog.setAttribute('open', '');
        }
        if (input) {
          input.value = hasFiniteStock ? String(Math.min(stockForVariant, QUANTITY_MAX_OPTIONS + 1)) : String(QUANTITY_MAX_OPTIONS + 1);
          try { input.focus(); input.select(); } catch (_) {}
        }
      });
    }

    function getNumericOptions(select) {
      return Array.prototype.filter.call(select.options, function(opt) {
        return opt.value !== QUANTITY_CUSTOM_VALUE;
      });
    }

    function selectIndexOfValue(options, value) {
      for (var i = 0; i < options.length; i++) {
        if (options[i].value === String(value)) return i;
      }
      return -1;
    }

    function dispatchCartQuantityUpdate(container, select, quantity) {
      var cartLineRaw = container.dataset.cartLine;
      if (!cartLineRaw) {
        qtyLog('dispatchCartQuantityUpdate: skipped (not cart context)', { quantity: quantity });
        return;
      }
      var cartLine = parseInt(cartLineRaw, 10);
      if (isNaN(cartLine) || cartLine <= 0) {
        qtyWarn('dispatchCartQuantityUpdate: invalid cart line', { cartLineRaw: cartLineRaw, quantity: quantity });
        return;
      }
      qtyLog('dispatchCartQuantityUpdate', { cartLine: cartLine, quantity: quantity, variantId: container.dataset.currentVariantId });
      var event = new CustomEvent('quantity-selector:update', {
        bubbles: true,
        detail: { quantity: quantity, cartLine: cartLine }
      });
      (select || container).dispatchEvent(event);
    }

    function isCartContext(container) {
      return !!container.dataset.cartLine;
    }

    function getContainerFromTarget(target) {
      if (!(target instanceof Element)) return null;
      return target.closest('[data-quantity-dropdown]');
    }

    function getLastValid(container, select) {
      var stored = lastValidByContainer.get(container);
      if (stored && stored !== QUANTITY_CUSTOM_VALUE) return stored;
      if (select && select.value && select.value !== QUANTITY_CUSTOM_VALUE) return select.value;
      return '1';
    }

    function setPendingCartQuantity(container, quantity) {
      if (!container || !container.dataset.cartLine) return;
      container.setAttribute('data-pending-quantity', String(quantity));
    }

    function clearPendingCartQuantity(container) {
      if (!container) return;
      container.removeAttribute('data-pending-quantity');
    }

    function restoreAllPendingQuantities() {
      document.querySelectorAll('[data-quantity-dropdown][data-pending-quantity]').forEach(function (container) {
        var pending = parseInt(container.getAttribute('data-pending-quantity') || '', 10);
        var select = container.querySelector('[data-quantity-select]');
        if (!select || isNaN(pending) || pending < 1) return;
        applyNumericValue(select, pending);
        lastValidByContainer.set(container, String(pending));
      });
    }

    window.__qtyDropdownRestorePending = restoreAllPendingQuantities;

    function commitSelectionAndNotify(container, select) {
      if (!container || !select) return;
      lastValidByContainer.set(container, select.value);
      qtyLog('commitSelectionAndNotify', {
        selectValue: select.value,
        cartLine: container.dataset.cartLine || null,
        cartContext: isCartContext(container)
      });
      if (!isCartContext(container)) return;
      var parsed = parseInt(select.value, 10);
      if (isNaN(parsed) || parsed < 0) parsed = 1;
      setPendingCartQuantity(container, parsed);
      dispatchCartQuantityUpdate(container, select, parsed);
    }

    function currentStock(container) {
      var map = getVariantStockMap(container);
      var variantId = container.dataset.currentVariantId;
      return getStockForVariant(map, variantId);
    }

    function openCustomQuantityDialogFor(container, select) {
      if (pendingDialogBySelect.get(select)) return;
      var stock = currentStock(container);
      var promise = showCustomQuantityDialog(stock);
      pendingDialogBySelect.set(select, promise);
      promise.then(function(value) {
        pendingDialogBySelect.delete(select);
        if (value == null) {
          select.value = getLastValid(container, select);
          return;
        }
        setCustomQuantity(select, value);
        commitSelectionAndNotify(container, select);
      });
    }

    // Find the surrounding cart line row (TR / .cart-items__table-row) so we
    // can surface inline errors (e.g. "Only N available in stock.") next to
    // the quantity selector, matching how Horizon's cart-items-component
    // displays validation errors returned from /cart/change.js.
    function findCartLineRow(container) {
      if (!container || !container.closest) return null;
      return container.closest('tr.cart-items__table-row') || container.closest('.cart-items__table-row');
    }

    function showCartLineError(container, message) {
      var row = findCartLineRow(container);
      qtyLog('showCartLineError', { message: message, rowFound: !!row });
      if (!row) {
        qtyWarn('showCartLineError: no cart row found — error not shown in UI', { message: message });
        return;
      }
      var errCt = row.querySelector('.cart-items__error');
      var errText = row.querySelector('.cart-item__error-text');
      if (errCt) errCt.classList.remove('hidden');
      if (errText) errText.textContent = message;
      else qtyWarn('showCartLineError: .cart-item__error-text not found in row');
    }

    function clearCartLineError(container) {
      var row = findCartLineRow(container);
      if (!row) return;
      var errCt = row.querySelector('.cart-items__error');
      if (errCt) errCt.classList.add('hidden');
    }

    function getMaxStockMessage(stock) {
      var translations = (window.Theme && window.Theme.translations) || {};
      var template = translations.custom_quantity_exceeds_stock || 'Allocation limit reached';
      return template.replace('__COUNT__', String(stock));
    }

    // Set the dropdown to an arbitrary positive integer, reusing an existing
    // numeric <option> if one is present, otherwise inserting a sticky
    // [data-custom-quantity] option before the trailing "+".
    function applyNumericValue(select, value) {
      setCustomQuantity(select, value);
    }

    // Delegated event handlers. One listener per event type at the document
    // level survives any number of cart-section morphs and never duplicates,
    // unlike per-element listeners that piled up after each cart update.
    document.addEventListener('change', function(e) {
      var target = e.target;
      if (!(target instanceof HTMLSelectElement)) return;
      if (!target.hasAttribute('data-quantity-select')) return;
      var container = getContainerFromTarget(target);
      if (!container) return;

      if (target.value === QUANTITY_CUSTOM_VALUE) {
        openCustomQuantityDialogFor(container, target);
        return;
      }
      clearCartLineError(container);
      commitSelectionAndNotify(container, target);
    });

    document.addEventListener('click', function(e) {
      var target = e.target;
      if (!(target instanceof Element)) return;
      var decrementBtn = target.closest('[data-qty-decrement]');
      var incrementBtn = target.closest('[data-qty-increment]');
      if (!decrementBtn && !incrementBtn) return;

      var container = getContainerFromTarget(decrementBtn || incrementBtn);
      var select = container ? container.querySelector('[data-quantity-select]') : null;
      var cartItemsRoot = container ? container.closest('cart-items-component') : null;
      var cartDisabled = !!(cartItemsRoot && cartItemsRoot.classList && cartItemsRoot.classList.contains('cart-items-disabled'));

      qtyLog(incrementBtn ? 'click: increment' : 'click: decrement', {
        targetTag: target.tagName,
        containerFound: !!container,
        selectFound: !!select,
        cartDisabled: cartDisabled,
        selectDisabled: select ? select.disabled : null,
        btnDisabled: incrementBtn ? incrementBtn.disabled : (decrementBtn ? decrementBtn.disabled : null)
      });

      if (!container) {
        qtyWarn('click: no [data-quantity-dropdown] container');
        return;
      }
      if (!select) {
        qtyWarn('click: no [data-quantity-select]');
        return;
      }

      e.preventDefault();

      if (cartDisabled) {
        qtyWarn('click: ignored — cart-items-component has .cart-items-disabled (update in progress?)');
        return;
      }
      if (select.disabled) {
        qtyWarn('click: ignored — select is disabled');
        return;
      }
      if (decrementBtn && decrementBtn.disabled) {
        qtyWarn('click: ignored — decrement button disabled');
        return;
      }
      if (incrementBtn && incrementBtn.disabled) {
        qtyWarn('click: ignored — increment button disabled');
        return;
      }

      // Operate on the actual numeric value rather than the dropdown's option
      // index. Custom-quantity values (e.g. 35 when stock > 24) aren't in the
      // 1..max numeric option list, so an index-based step would snap back to
      // 1 or behave wrong; value-based stepping is correct in every case.
      var currentVal = parseInt(select.value, 10);
      if (isNaN(currentVal) || currentVal < 1) currentVal = 1;

      var stock = currentStock(container);
      var unlimited = stock == null || stock < 0;
      var variantStockMap = getVariantStockMap(container);

      qtyLog('stepper state', {
        action: incrementBtn ? 'increment' : 'decrement',
        selectValue: select.value,
        currentVal: currentVal,
        stock: stock,
        unlimited: unlimited,
        variantId: container.dataset.currentVariantId,
        variantStockMap: variantStockMap,
        cartLine: container.dataset.cartLine || null
      });

      if (decrementBtn) {
        clearCartLineError(container);
        var nextDown = currentVal - 1;
        if (nextDown < 1) {
          if (isCartContext(container)) {
            var parsedCartMin = parseInt(container.dataset.cartMin || '0', 10);
            if (!isNaN(parsedCartMin) && parsedCartMin === 0) {
              dispatchCartQuantityUpdate(container, select, 0);
            }
          }
          qtyLog('decrement: at min, remove line or noop', { nextDown: nextDown });
          return;
        }
        applyNumericValue(select, nextDown);
        commitSelectionAndNotify(container, select);
        return;
      }

      // increment
      var nextUp = currentVal + 1;
      if (!unlimited && nextUp > stock) {
        qtyWarn('increment blocked: would exceed stock', { currentVal: currentVal, nextUp: nextUp, stock: stock });
        if (isCartContext(container)) {
          showCartLineError(container, getMaxStockMessage(stock));
        }
        return;
      }
      clearCartLineError(container);
      qtyLog('increment: applying', { nextUp: nextUp, selectValueBefore: select.value });
      applyNumericValue(select, nextUp);
      qtyLog('increment: after applyNumericValue', { selectValue: select.value });
      commitSelectionAndNotify(container, select);
    }, true);

    // Re-sync the lastValid cache and dropdown value whenever a new cart line
    // appears (initial render, cart drawer open, after morph). The server is
    // the source of truth for in-cart quantity; we mirror it into our cache.
    function syncContainerFromServer(container) {
      if (container.hasAttribute('data-pending-quantity')) return;
      var select = container.querySelector('[data-quantity-select]');
      if (!select) return;
      if (select.value && select.value !== QUANTITY_CUSTOM_VALUE) {
        lastValidByContainer.set(container, select.value);
      }
    }

    function syncAll() {
      document.querySelectorAll('[data-quantity-dropdown]').forEach(syncContainerFromServer);
    }

    function handleVariantUpdate(e) {
      var detail = e && e.detail;
      var resource = detail && detail.resource;
      var variantId = resource && resource.id;
      if (!variantId) return;
      var productId = detail && detail.data && detail.data.productId;

      document.querySelectorAll('[data-quantity-dropdown]').forEach(function(container) {
        if (container.dataset.cartLine) return;
        if (productId && container.dataset.productId && String(container.dataset.productId) !== String(productId)) return;
        container.dataset.currentVariantId = String(variantId);
        var map = getVariantStockMap(container);
        var stock = getStockForVariant(map, variantId);
        var select = container.querySelector('[data-quantity-select]');
        if (!select) return;
        rebuildQuantityOptions(select, stock);
        select.disabled = resource.available === false;
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', syncAll);
    } else {
      syncAll();
    }
  document.addEventListener('shopify:section:load', syncAll);
  document.addEventListener('cart:update', syncAll);
  document.addEventListener('variant:update', handleVariantUpdate);
})();
